// extracted by mini-css-extract-plugin
export var container = "IconList-module--container--3yjTt";
export var gridFix = "IconList-module--grid-fix--2N4yL";
export var ul = "IconList-module--ul--88Khd";
export var column = "IconList-module--column--2YAUB";
export var imageContainer = "IconList-module--image-container--zZG6Q";
export var half = "IconList-module--half--BKl9q";